import {
  createContext,
  Dispatch,
  FunctionComponent,
  SetStateAction,
  useState,
} from 'react';

interface SafeAndRetrieveContextProps {
  saveAndRetrieveConsent: boolean;
  setSaveAndRetrieveConsent: Dispatch<boolean>;
  saveAndRetrieveDeleteId?: string;
  setSaveAndRetrieveDeleteId: Dispatch<string | undefined>;
  pendingSarResumeStepIndex?: number;
  setPendingSarResumeStepIndex?: Dispatch<SetStateAction<number | undefined>>;
}

export const SafeAndRetrieveContext =
  createContext<SafeAndRetrieveContextProps>({} as SafeAndRetrieveContextProps);

const SaveAndRetrieveProvider: FunctionComponent = ({ children }) => {
  const [saveAndRetrieveConsent, setSaveAndRetrieveConsent] =
    useState<boolean>(false);
  const [saveAndRetrieveDeleteId, setSaveAndRetrieveDeleteId] = useState<
    string | undefined
  >();
  const [pendingSarResumeStepIndex, setPendingSarResumeStepIndex] = useState<
    number | undefined
  >();
  return (
    <SafeAndRetrieveContext.Provider
      value={{
        saveAndRetrieveConsent,
        setSaveAndRetrieveConsent,
        saveAndRetrieveDeleteId,
        setSaveAndRetrieveDeleteId,
        pendingSarResumeStepIndex,
        setPendingSarResumeStepIndex,
      }}
    >
      {children}
    </SafeAndRetrieveContext.Provider>
  );
};

export default SaveAndRetrieveProvider;
